import { useCourier } from '@trycourier/courier-react'
import { CourierInboxDataStoreListener, CourierInboxDatastore } from '@trycourier/courier-ui-inbox'
import { useSession } from 'next-auth/react'
import { PropsWithChildren, useEffect } from 'react'
import { useIsMobileWidth } from '@omnea-app/fe-browser-utils/useDetectDevice'
import { NotificationToast } from '../../headers/NotificationInbox'
import { useInvalidateRequestsAndTasksQueries } from './useInvalidateRequestsAndTasksQueries'

export const NotificationProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const session = useSession()
  const userId = session.data?.user?.metadata?.id
  const courierToken = session.data?.user?.metadata?.courierToken
  const isMobile = useIsMobileWidth()
  const { shared } = useCourier()
  const invalidateQueries = useInvalidateRequestsAndTasksQueries()

  useEffect(() => {
    if (!userId || !courierToken) {
      return
    }
    shared.signIn({ userId, jwt: courierToken })
    void CourierInboxDatastore.shared.listenForUpdates()
    return () => shared.signOut()
  }, [shared, userId, courierToken])

  useEffect(() => {
    const listener = new CourierInboxDataStoreListener({ onMessageAdd: () => invalidateQueries() })
    CourierInboxDatastore.shared.addDataStoreListener(listener)
    return () => listener.remove()
  }, [invalidateQueries])

  return (
    <>
      {!isMobile && <NotificationToast />}
      {children}
    </>
  )
}
